module.exports = __webpack_public_path__ + "img/weixinhao.398c34c5.png";